import { render, staticRenderFns } from "./SaveArticleButton.vue?vue&type=template&id=53bbf0ad"
import script from "./SaveArticleButton.vue?vue&type=script&lang=js"
export * from "./SaveArticleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports